export default {
  methods: {
    format_question_type(type) {
      if (!type || typeof type !== 'string') {
        return "Unknown Type";
      }

      if (type === "Vetted") {
        return "Approved";
      }

      return type.charAt(0).toUpperCase() + type.slice(1).replace(/_/g, ' ');
    },

    format_date(dateString, fall_back_message = "-") {
      const date = new Date(dateString);

      if (dateString === null || isNaN(date.getTime())) return fall_back_message;//fallback for invalid dates


      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      const ampm = hours >= 12 ? 'pm' : 'am';
      hours = String(hours % 12 || 12).padStart(2, '0');

      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}${ampm}`;
    }
  }
};
